import TableGame from '../../../System/TableGame';
import DataType from '../Config/DataStructure';

export default class Result {
    public readonly totalBet: number = 0;
    public readonly totalWin: number = 0;
    public readonly gameBet: number = 0;
    public readonly gameWin: number = 0;
    public readonly balance: number = 0;
    public readonly roundID: number = 0;
    public readonly status: DataType.Enums.ResultStatus = 0;

    constructor(data: DataType.Table.PlayerSettleData) {
        // basic info
        this.totalBet = data.TotalBet ?? 0;
        this.totalWin = data.TotalWin ?? 0;
        this.gameBet = data.TotalGameBet ?? 0;
        this.gameWin = data.TotalGameWin ?? 0;
        this.balance = data.Balance ?? TableGame.user.balance; // use current balance if not provided
        this.status = data.Status ?? undefined;
    }

    public get isCancelled() {
        return this.status === DataType.Enums.ResultStatus.Cancelled;
    }

    public get netWin() {
        return this.totalWin - this.totalBet;
    }
}
